/**
 * @generated SignedSource<<8a4ef42827d93a555f1cfa1f272a8489>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ScheduleDayOfMonth = "FIRST_WORKING_DAY" | "LAST_WORKING_DAY" | "DAY_1" | "DAY_15" | "LAST_DAY" | "FIRST_MONDAY" | "LAST_FRIDAY" | "%future added value";
export type ScheduleFrequency = "WEEKLY" | "BIWEEKLY" | "FOUR_WEEKLY" | "MONTHLY" | "QUARTERLY" | "%future added value";
export type ScheduleWeekday = "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ScheduleDrawerContent_scheduleSet$data = {
  readonly id: string;
  readonly consumer: string;
  readonly enabled: boolean;
  readonly schedules: ReadonlyArray<{
    readonly id: string;
    readonly scheduleId: string;
    readonly frequency: ScheduleFrequency;
    readonly dayOfMonth: ScheduleDayOfMonth | null;
    readonly weekdays: ReadonlyArray<ScheduleWeekday>;
    readonly timeOfDay: string;
    readonly timezone: string;
  }>;
  readonly " $fragmentType": "ScheduleDrawerContent_scheduleSet";
};
export type ScheduleDrawerContent_scheduleSet$key = {
  readonly " $data"?: ScheduleDrawerContent_scheduleSet$data;
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleDrawerContent_scheduleSet">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScheduleDrawerContent_scheduleSet",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "consumer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Schedule",
      "kind": "LinkedField",
      "name": "schedules",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scheduleId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "frequency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dayOfMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weekdays",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeOfDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timezone",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ScheduleSet",
  "abstractKey": null
};
})();

(node as any).hash = "6227f433445760d03b35a2019cc547af";

export default node;
